import React from "react";
import {
  JobEntityType,
  JobEntityTypeColors,
} from "../../models/Jobs/JobEntityType";
import { Badge } from "../ui/badge";
import ConfirmationModal from "../common/ConfirmationModal";

interface ConfirmMigrationEntitiesExportToCsvModalConfig {
  migrationEntityType: string;
  jobEntityType: JobEntityType;
}

interface ConfirmMigrationEntitiesExportToCsvModalProps {
  open: boolean;
  entityKeys: string[];
  exportFilesData: boolean;
  config: ConfirmMigrationEntitiesExportToCsvModalConfig;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmMigrationEntitiesExportToCsvModal: React.FC<ConfirmMigrationEntitiesExportToCsvModalProps> = ({
  open,
  entityKeys,
  exportFilesData,
  config,
  onClose,
  onConfirm,
}: ConfirmMigrationEntitiesExportToCsvModalProps) => {
  const getMessage = (): string => {
    const dataStatus = exportFilesData ? "with" : "without";
    return `Are you sure you want to export ${config.migrationEntityType} ${dataStatus} their files data?`;
  };

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      message={getMessage()}
      statusColor="primary"
      buttonText="Confirm"
      maxWidth="35%"
    >
      <div className="mt-4 flex flex-row flex-wrap items-center justify-center gap-2">
        {entityKeys.map((entityNumber) => (
          <Badge
            key={entityNumber}
            variant={JobEntityTypeColors[config.jobEntityType]}
          >
            {entityNumber}
          </Badge>
        ))}
      </div>
    </ConfirmationModal>
  );
};

export default ConfirmMigrationEntitiesExportToCsvModal;

export const CONFIRM_MIGRATION_ENTITIES_EXPORT_CONFIGS = {
  CASES: {
    migrationEntityType: "cases",
    jobEntityType: JobEntityType.Case,
  },
  INTAKES: {
    migrationEntityType: "intakes",
    jobEntityType: JobEntityType.Intake,
  },
  PROVIDERS: {
    migrationEntityType: "providers",
    jobEntityType: JobEntityType.Provider,
  },
  FIRM_DOCUMENTS_FOLDERS: {
    migrationEntityType: "firm documents folders",
    jobEntityType: JobEntityType.FirmDocumentsFolder,
  },
  TEMPLATES_LIBRARIES: {
    migrationEntityType: "templates libraries",
    jobEntityType: JobEntityType.FirmDocumentsFolder,
  },
} as const;
